"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeVariantDatasetFromDistributorCatalog = void 0;
const routes_1 = require("../../routes");
const removeVariantDatasetFromDistributorCatalog = (client) => async (distributorId, variantId) => {
    await client.delete(routes_1.ENDPOINTS.REMOVE_VARIANT_DATASET_FROM_PARTNER_CATALOG.applyParams(distributorId, variantId));
};
exports.removeVariantDatasetFromDistributorCatalog = removeVariantDatasetFromDistributorCatalog;
